import Bowser from 'bowser'

export default function() {
  const ua = navigator.userAgent
  const browser = Bowser.getParser(ua)

  const isMobile = browser.isPlatform('mobile')
                   || browser.isPlatform('tablet')
                   // ↓iPadOS13を検出するための判定
                   || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

  /**
   * NOTE: 各ブラウザのgetDisplayMedia対応状況
   * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#Browser_compatibility
   */
  const isSupportedDisplayMedia = !!browser.satisfies({
    desktop: {
      chrome: ">=72",
      firefox: ">66",
      safari: ">=13",
      opera: ">=60",
      'microsoft edge': ">=79"
    }
  }) && !isMobile

  return {
    isMobile: isMobile,
    isSupportedDisplayMedia: isSupportedDisplayMedia
  };
}
